import { Info, Search } from "@mui/icons-material";
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormLabel,
  InputAdornment,
  MenuItem,
  Stack,
  TextField,
  Tooltip,
} from "@mui/material";
import { useDebouncedHandler } from "../../App/State/Hooks/useDebouncedHandler";
import { IGroup } from "../../App/Typings/Groups";
import { useFilterContext } from "../State/FilterContext";
import { useGroupsContext } from "../State/GroupsContext";

export default function ContactListFilters() {
  const { groups, groupsFetched, selectedGroupIds, setSelectedGroupIds } = useGroupsContext();
  const { search, setSearch, unreadOnly, setUnreadOnly } = useFilterContext();

  const inputSearchFilter = useDebouncedHandler((ev: React.ChangeEvent<HTMLInputElement>) => {
    if (!ev.target.value || ev.target.value.length >= 2) {
      setSearch(ev.target.value);
    }
  }, 500); //<-- Desired timeout

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      alignItems={{ xs: "strech", sm: "flex-start" }}
      spacing={2}
    >
      <Box sx={{ width: { xs: "100%", sm: 300 } }}>
        <TextField
          fullWidth
          data-test={"messaging-contact-search"}
          placeholder={'... "John Doe"'}
          defaultValue={search}
          label={"Search"}
          onChange={inputSearchFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <Box
        sx={{
          width: {
            xs: "100%",
            sm: 300,
          },
        }}
      >
        <TextField
          id="contact-group-select"
          data-test="messaging-contact-group-select"
          label={!groupsFetched ? "Loading Groups" : "Groups"}
          select
          fullWidth
          disabled={!groupsFetched}
          SelectProps={{
            multiple: true,
            value: selectedGroupIds,
            onChange: (ev) => {
              const vals = String(ev.target.value)
                .split(",")
                .filter((c) => c !== "");

              setSelectedGroupIds(vals);
            },
          }}
        >
          {getMenuItems(groups)}
        </TextField>
      </Box>
      <Box>
        <FormControlLabel
          control={
            <Checkbox
              disableRipple
              style={{ justifyContent: "flex-start" }}
              id="unread-only"
              checked={unreadOnly}
              onChange={(_ev, val) => setUnreadOnly(val)}
              data-test="contact-unread-only-check"
            />
          }
          label={
            <FormLabel htmlFor="unread-only" sx={{ fontWeight: "bold", mb: 1 }}>
              Unread only
              <Tooltip
                sx={{ marginLeft: "3px", padding: "2px", marginTop: "-5px" }}
                title={"Filter candidates with unread messages"}
              >
                <Info fontSize="small" />
              </Tooltip>
            </FormLabel>
          }
        />
      </Box>
    </Stack>
  );
}

const getMenuItems = (groups: IGroup[]) => {
  return groups
    .sort((a, b) => {
      if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
      if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;

      return 0;
    })
    .map((option) => (
      <MenuItem key={option.id} value={option.id} data-test={`message-group-filter-${option.id}`}>
        {option.name} ({option.memberCount})
      </MenuItem>
    ));
};
